import { render, staticRenderFns } from "./GroupScreen.vue?vue&type=template&id=23ff9494&scoped=true&"
import script from "./GroupScreen.vue?vue&type=script&lang=js&"
export * from "./GroupScreen.vue?vue&type=script&lang=js&"
import style0 from "./GroupScreen.vue?vue&type=style&index=0&id=23ff9494&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ff9494",
  null
  
)

export default component.exports